import React from "react";

function LoadingIndicator() {
  return <div className="LoadingIndicator">Loading...</div>;
}

export default LoadingIndicator;
